import { ControlPropertyType } from '../../../enums';
import { InputSlotType } from '../../../shared/input/enums';

export const OptionProperty = {
  Value: 'value',
  Label: 'label',
  Disabled: 'disabled',
};

export const SelectProperty = {
  ...ControlPropertyType,
  FillType: 'fillType',
  Multiple: 'multiple',
  Options: 'options',
  Filterable: 'filterable',
  NoValueOption: 'noValueOption',
  InputValue: 'inputValue',
  InputChangeHandler: 'inputChangeHandler',
  IsLoading: 'isLoading',
};

export const SelectedListProperty = {
  Value: SelectProperty.Value,
  Options: SelectProperty.Options,
  ColorScheme: SelectProperty.ColorScheme,
};

export const SelectedListEventType = {
  RemoveOption: 'removeOption',
};

export const SelectSlotType = {
  ...InputSlotType,
  Option: 'option',
};
